import { Image, Element, RouterLink } from '@zmedia/bm-soccer-ui/components';
import { memo } from 'react';
import { ITeam } from '@zmedia/bm-soccer-ui/interface';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import styles from './style.module.scss';

interface IProps {
    team: ITeam;
    isLink?: boolean;
}

export function Team({ team, isLink = false }: IProps) {
    if (!team) {
        return null;
    }

    if (isLink) {
        return (
            <RouterLink
                className={styles['team-item']}
                to={`${URL_SOCCER_PAGE.SUBPATH}${team.path}`}
                title={team.name}
            >
                <Element className={styles['team-text']}>{team.name}</Element>
                <Image src={team.logo} alt={'Đội bóng ' + team.name} />
            </RouterLink>
        );
    }
    return (
        <Element className={styles['team-item']}>
            <Element className={styles['team-text']}>{team.name}</Element>
            <Image src={team.logo} alt={'Đội bóng ' + team.name} />
        </Element>
    );
}

export default memo(Team);
